import touch from './src/touch' 
import move from './src/move' 
import setBroadCart from './src/setBroadCart' 

const derictives:any={
    touch,move,setBroadCart
}


export default derictives;